/* eslint-disable @typescript-eslint/naming-convention */
import { stringifyUrl } from 'query-string';

type ProjectUrlParams = {
    projectId: string;
    filter?: string;
    branch?: string;
    view?: 'multi' | 'single';
    singleLangId?: string;
};

// eslint-disable-next-line import/prefer-default-export
export const projectUrlWithParams = ({ projectId, filter, branch, view = 'multi', singleLangId }: ProjectUrlParams) =>
    stringifyUrl({
        url: `/project/${projectId}/`,
        query: {
            view,
            filter,
            branch,
            single_lang_id: singleLangId,
        },
    });
